// Animation duration constant
const ANIMATION_DURATION = 1100;

// Helper functions for class manipulation
function hasClass(element, className) {
    return element.classList.contains(className);
}

function addClass(element, className) {
    element.classList.add(className);
}

function removeClass(element, className) {
    element.classList.remove(className);
}

// Main initialization when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Mobile navigation menu
    const burger = document.querySelector('.burgerMenu');
    const nav = document.querySelector('.navMobile');
    const navLinks = document.querySelectorAll('.navMobile a');
    const closeBanner = document.getElementById('close-banner');
    const banner = document.getElementById('banner');

    // Burger menu toggle functionality
    if (burger && nav) {
        burger.addEventListener('click', function() {
            if (!hasClass(burger, 'transition')) {
                const isOpen = hasClass(burger, 'open');
                
                if (isOpen) {
                    // Close menu
                    navLinks.forEach(function(link) {
                        removeClass(link, '!translate-x-0');
                    });
                    addClass(burger, 'transition');
                    burger.setAttribute('aria-expanded', 'false');
                    setTimeout(function() {
                        removeClass(nav, 'left-0');
                        addClass(nav, 'left-full');
                        removeClass(burger, 'open');
                        removeClass(burger, 'transition');
                    }, ANIMATION_DURATION);
                } else {
                    // Open menu
                    removeClass(nav, 'left-full');
                    addClass(nav, 'left-0');
                    addClass(burger, 'open');
                    burger.setAttribute('aria-expanded', 'true');
                    navLinks.forEach(function(link) {
                        addClass(link, '!translate-x-0');
                    });
                    addClass(burger, 'transition');
                    setTimeout(function() {
                        addClass(burger, 'open');
                        removeClass(burger, 'transition');
                    }, ANIMATION_DURATION);
                }
            }
        });
    }

    // Panier de la boutique : boutique.risonnable.fr partage le nombre d'articles via un cookie sur .risonnable.fr
    const cartFloat = document.querySelector('.cart-float');
    const cartCookie = document.cookie.match(/(?:^|;\s*)risonnable_panier=(\d+)/);
    const cartCount = cartCookie ? parseInt(cartCookie[1], 10) : 0;
    if (cartFloat && cartCount > 0) {
        cartFloat.querySelector('.cart-float-count').textContent = cartCount;
        addClass(cartFloat, 'is-visible');
    }

    // Nuancier de l'accueil : copie le code hexadécimal au clic
    document.querySelectorAll('.color-swatch').forEach(function(swatch) {
        const label = swatch.querySelector('.color-swatch-feedback');
        let resetTimer;
        // Angle tiré au hasard à chaque survol, entre -20° et +20° en évitant les angles trop proches de 0
        swatch.addEventListener('mouseenter', function() {
            const angle = (5 + Math.random() * 15) * (Math.random() < 0.5 ? -1 : 1);
            swatch.style.setProperty('--swatch-rotate', angle.toFixed(1) + 'deg');
        });
        swatch.addEventListener('click', function() {
            const hex = swatch.dataset.hex;
            // Repli sur execCommand quand l'API Clipboard est absente ou refusée
            const fallbackCopy = function() {
                const field = document.createElement('textarea');
                field.value = hex;
                field.setAttribute('readonly', '');
                field.style.position = 'fixed';
                field.style.opacity = '0';
                document.body.appendChild(field);
                field.select();
                const copied = document.execCommand('copy');
                document.body.removeChild(field);
                label.textContent = copied ? 'Copié !' : 'Copie impossible';
            };
            if (navigator.clipboard) {
                navigator.clipboard.writeText(hex).then(function() {
                    label.textContent = 'Copié !';
                }, fallbackCopy);
            } else {
                fallbackCopy();
            }
            clearTimeout(resetTimer);
            resetTimer = setTimeout(function() {
                label.textContent = '';
            }, 1500);
        });
    });

    // FAQ accordion functionality
    const faqSection = document.getElementById('faq');
    if (faqSection) {
        const questions = document.querySelectorAll('.question');
        questions.forEach(function(question) {
            question.addEventListener('click', function() {
                const answer = question.querySelector('.answer');
                const indicator = question.querySelector('.indicator');
                
                if (answer && indicator) {
                    if (hasClass(answer, 'max-h-0')) {
                        removeClass(answer, 'max-h-0');
                        addClass(answer, 'max-h-96');
                        indicator.textContent = '-';
                    } else {
                        addClass(answer, 'max-h-0');
                        removeClass(answer, 'max-h-96');
                        indicator.textContent = '+';
                    }
                }
            });
        });
    }
});